import { CrxLoading, CrxInputSelect, CrxFlag } from '@cortex/cortex-core'
import { Sector } from 'types/sector'
import { UseFormWatch, UseFormSetValue, FieldErrors } from 'react-hook-form'
import { SectorFormData } from '../schemas/sectorSchema'

interface SectorTransferSectionProps {
  isLoading: boolean
  hasNotifications: boolean | null
  availableSectors: Sector[]
  watch: UseFormWatch<SectorFormData>
  setValue: UseFormSetValue<SectorFormData>
  errors: FieldErrors<SectorFormData>
}

export const SectorTransferSection = ({
  isLoading,
  hasNotifications,
  availableSectors,
  watch,
  setValue,
  errors
}: SectorTransferSectionProps) => {
  const transferSectorId = watch('transferSectorId')
  
  const handleTransferSectorChange = (sectorId: string) => {
    setValue('transferSectorId', sectorId, { shouldDirty: true, shouldValidate: true })
  }
  if (isLoading) {
    return (
      <div className="flex justify-center py-4">
        <CrxLoading />
      </div>
    )
  }

  if (hasNotifications === false) {
    return (
      <div className="font-semibold text-typograpy-1 text-sm font-Roboto">
        Não há notificações registradas neste setor.
      </div>
    )
  }

  if (hasNotifications === true) {
    return (
      <div className="space-y-4">
        <p className="text-sm font-medium text-typograpy-1 font-Roboto">
          Antes de inativar um setor, selecione para qual setor ativo as notificações em aberto dele devem ser transferidas:
        </p>

        <CrxInputSelect
          id="input-select-transfer-sector"
          label="Setor de destino"
          placeholder="Selecione um setor"
          required
          error={!!errors.transferSectorId}
          supportText={errors.transferSectorId?.message || ''}
          value={
            transferSectorId
              ? availableSectors.find(s => s.sys_id === transferSectorId)?.u_name || ''
              : ''
          }
          // @ts-ignore
          onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
            const selectedName = e.target.value
            const selectedSector = availableSectors.find(s => s.u_name === selectedName)
            if (selectedSector) {
              handleTransferSectorChange(selectedSector.sys_id)
            }
          }}
        >
          {availableSectors.map(sector => (
            <option key={sector.sys_id} value={sector.u_name}>
              {sector.u_name}
            </option>
          ))}
        </CrxInputSelect>

        <CrxFlag
          type="informative"
        >
          <span className='text-sm font-Roboto'>
            Serão transferidas apenas as notificações com os seguintes status:
            <span className='text-sm font-bold font-Roboto'> Nova, Aguardando, Em tratamento e Pendente finalização.</span><br />
            As notificações já finalizadas permanecerão vinculadas ao setor original.
          </span>
        </CrxFlag>
      </div>
    )
  }

  return null
}